export default "__VITE_ASSET__f21228e8__"